import { render, staticRenderFns } from "./FarmBulkImportHistoryTab.vue?vue&type=template&id=b11b98d6"
import script from "./FarmBulkImportHistoryTab.vue?vue&type=script&lang=js"
export * from "./FarmBulkImportHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports